import { NgClass, NgStyle } from '@angular/common';
import {
  Component,
  OnInit,
  ViewContainerRef,
  ComponentRef,
  ViewChild,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DialogDataInterface } from './../services/dialog.service';

@Component({
  selector: 'mb-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgStyle, TranslatePipe],
})
export class DialogComponent implements OnInit, OnDestroy {
  data = inject<DialogDataInterface>(MAT_DIALOG_DATA);
  private mdDialogRef = inject<MatDialogRef<DialogComponent>>(MatDialogRef);
  @ViewChild('dialogChild', { read: ViewContainerRef, static: true }) private dialogChild!: ViewContainerRef;

  title!: string;
  active!: number;
  component!: ComponentRef<any>;

  public disableCloseBtn = false;
  public disableBackdropClose = false;
  public style = {};
  public classList: string | string[] | Set<string> | { [klass: string]: any } = '';
  public backgroundClass: string | string[] | Set<string> | { [klass: string]: any } = '';
  public destroy$ = new Subject<boolean>();

  constructor() {
    this.mdDialogRef.disableClose = true;
  }

  public close() {
    this.mdDialogRef.close(true);
  }

  public onBackdropClick() {
    if (!this.disableBackdropClose) {
      this.close();
    }
  }

  ngOnInit() {
    this.title = this.data.title || '';
    this.style = this.data.style || {};
    this.classList = this.data.classList || '';
    this.backgroundClass = this.data.backgroundClass || '';
    this.disableCloseBtn = !!this.data.disableCloseBtn;
    this.disableBackdropClose = !!this.data.disableBackdropClose;
    this.component = this.dialogChild.createComponent(this.data.component);
    for (const i in this.data.inputs) {
      if (this.data.inputs.hasOwnProperty(i)) {
        this.component.instance[i] = this.data.inputs[i];
      }
    }
    for (const i in this.data.outputs) {
      if (this.data.outputs.hasOwnProperty(i)) {
        this.component.instance[i].pipe(takeUntil(this.destroy$)).subscribe((event: any) => {
          if (this.data.outputs && this.data.outputs[i]) {
            this.data.outputs[i](event);
          }
        });
      }
    }
  }

  ngOnDestroy() {
    this.component.destroy();
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
